function isEmpty(item) {
  if (typeof item === 'undefined' || item === null) {
    return true;
  }
}

function reverse(map, idKey) {
  const reversed = {};
  for (const key in map) {
    if (Object.hasOwnProperty.call(map, key)) {
      if (typeof map[key] !== 'object') {
        reversed[map[key]] = key;
      } else {
        if (map[key][idKey]) {
          reversed[map[key][idKey]] = { ...map[key], id: key };
        }
      }
    }
  }
  return reversed;
}

export default {
  isEmpty,
  reverse
};

export {
  isEmpty,
  reverse
};
